// extracted by mini-css-extract-plugin
export var label = "_4p-1";
export var reminder = "_4p-0";